import amapi from '@/api/amapi'

const initialState = () => ({
  events: [],
})

const state = initialState

const getters = {
  events: state => state.events,
}

const mutations = {
  SET_EVENTS (state, events) {
    state.events = events
  },
  CLEAR_DOWNTIME_STORE (state) {
    const s = initialState()

    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

const actions = {
  async getDowntimeList ({ commit }) {
    try {
      const { downtime } = await amapi.makecall('incidents')
      commit('SET_EVENTS', downtime)
    } catch (e) {
      throw e
    }
  },
  async getDowntimeEntry ({ commit }, id) {
    try {
      return amapi.makecall('incident_view', { id })
    } catch (e) {
      throw e
    }
  }
}
const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
